module.exports = __webpack_public_path__ + "img/donante-sublime-milenio.ab21473b.jpeg";